/*
 *  Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 *  Author Rihard Tsybulka <rykhard.tsybulka@noogadev.com>
 */

import { DocumentDetailsAction, DocumentDetailsActionType } from '../actions/documentDetailsActions';
import { DocumentResource } from '../api/documents/documentsClient.typings';

export interface DocumentDetailsState {
    isLoading: boolean;
    documentDetails: DocumentResource;
}

const initialState: DocumentDetailsState = {
    isLoading: false,
    documentDetails: null,
};

function documentDetailsReducer(
    state: DocumentDetailsState = initialState,
    action: DocumentDetailsAction,
): DocumentDetailsState {
    switch (action.type) {
        case DocumentDetailsActionType.OPEN_REGISTRY_DOCUMENT_CARD_PAGE:
            return {
                ...state,
                isLoading: true,
            };

        case DocumentDetailsActionType.FETCH_DOCUMENT_CARD_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                documentDetails: action.payload,
            };

        case DocumentDetailsActionType.FETCH_DOCUMENT_CARD_DETAILS_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case DocumentDetailsActionType.EXIT_REGISTRY_DOCUMENT_CARD_PAGE:
            return {
                ...state,
                isLoading: false,
                documentDetails: null,
            };

        default:
            return state;
    }
}

export default documentDetailsReducer;
